import { api } from "./api";

export const Alerts = api.injectEndpoints({
    endpoints: (builder) => ({
        getAllNotifications: builder.query<any, void>({
            query: () => ({
                url: "/Notifications/GetUserNotifications",
                method: "GET",
            }),
            providesTags: ["AllNotifications"]
        }),
        getUnreadNotificationsCount: builder.query<any, void>({
            query: () => ({
                url: "/Notifications/GetUnreadNotificationsCount",
                method: "GET"
            }),
            providesTags: ["UnreadNotificationsCount"]
        }),
        markNotificationAsRead: builder.mutation<any, { notificationGuid: string }>({
            query: (body) => ({
                url: "/Notifications/MarkNotificationRead",
                body: body,
                method: "POST"
            }),
            invalidatesTags: ["AllNotifications", "UnreadNotificationsCount"]
        }),
    })
})

export const {
    useGetAllNotificationsQuery,
    useGetUnreadNotificationsCountQuery,
    useLazyGetUnreadNotificationsCountQuery,
    useMarkNotificationAsReadMutation
} = Alerts;